import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/sections/Navbar";
import HeroSection from "./components/sections/HeroSection";
import TeamSection from "./components/sections/TeamSection";
import StopApplyingSection from "./components/sections/StopApplyingSection";
import WhySection from "./components/sections/WhySection";
import ProductsSection from "./components/sections/ProductsSection";
import StatsSection from "./components/sections/StatsSection";
import HowItWorks from "./components/sections/HowItWorks";
import PricingSection from "./components/sections/PricingSection";
import TestimonialsAndFAQ from "./components/sections/TestimonialsAndFAQ";
import AboutUs from "./components/pages/AboutUs";
import { MessageCircle } from "lucide-react";

const HomePage = () => (
  <>
    <Navbar />
    <HeroSection />
    <TeamSection />
    <StopApplyingSection />
    <WhySection />
    <ProductsSection />
    <StatsSection />
    <HowItWorks />
    <PricingSection />
    <TestimonialsAndFAQ />

    {/* WhatsApp Floating Button */}
    <a
      href="https://wa.me/447825296249?text=Hi%20I%20want%20help%20with%20job%20applications"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-2 bg-white shadow-lg rounded-full px-4 py-3 border border-gray-100 hover:shadow-xl transition-shadow duration-300 group"
    >
      <MessageCircle size={20} className="text-green-500" />
      <span className="text-sm font-medium text-gray-700 group-hover:text-green-600 transition-colors">WhatsApp Us</span>
    </a>
  </>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutUs />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
